export default __webpack_public_path__ + "static/media/news2402292.4e3ed945.jpg";